import PropTypes from "prop-types";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import { Button, Flex, Input } from "antd";
import "./pages.scss";
import { FileFilled, PlusOutlined } from "@ant-design/icons";

export const Pages = ({ handleState }) => {
    const { layoutList, layoutTitle } = useSelector((state) => state.present);
    const dispatch = useDispatch();
    const [newTitle, setNewTitle] = useState("");

    const getKeyArray = () => {
        return layoutList.map((value) => {
            return value[0];
        });
    };

    const changeLayoutState = (titleValue) => {
        const selectedLayout = layoutList.filter((item) => {
            if (item[0] === titleValue) {
                return item;
            }
        });
        dispatch(
            actionTypes.layout({
                titleLayout: titleValue,
                layout: selectedLayout[0][1],
            })
        );
    };

    const setTitleValueInRedux = () => {
        const pageExist = getKeyArray().filter((title) => {
            return title == newTitle;
        });
        if (
            (newTitle.length > 0) &
            (newTitle.length < 40) &
            (pageExist.length == 0) &
            (layoutList.length < 30)
        ) {
            dispatch(actionTypes.set_layout_title(newTitle));
            dispatch(actionTypes.set_default_page(newTitle));
        }
        handleState({
            newLayoutTitle: "",
        });
        setNewTitle("")
    };

    return (
        <Flex
            vertical
            gap={24}
            style={{
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            <Flex className="create-page-form">
                <Input
                    placeholder="Enter Page Title"
                    value={newTitle}
                    maxLength={40}
                    onChange={(event) => setNewTitle(event.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === "Enter") {
                            setTitleValueInRedux();
                        }
                    }}
                    status={newTitle.length >= 40 ? "error" : ""}
                />
                <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                        setTitleValueInRedux();
                        handleState({ newChangeDetected: true });
                    }}
                />
            </Flex>
            <Flex vertical gap={12} className="page-item-container">
                {getKeyArray().map((item, index) => {
                    return (
                        <div
                            key={index}
                            className={`page-item ${
                                layoutTitle == item ? "active" : ""
                            }`}
                            onClick={() => {
                                changeLayoutState(item, index);
                            }}
                        >
                            <FileFilled style={{ marginRight: 12 }} />
                            {item}
                        </div>
                    );
                })}
            </Flex>
        </Flex>
    );
};

Pages.propTypes = {
    handleState: PropTypes.func,
};
